import React, { useState, useEffect } from "react";
import Papa from "papaparse";

export default function CSVPreview({ csvUrl }) {
  const [data, setData] = useState([]);
  const [headers, setHeaders] = useState([]);

  useEffect(() => {
    const fetchCSV = async () => {
      try {
        const response = await fetch(csvUrl);
        const csvText = await response.text();

        Papa.parse(csvText, {
          header: true,
          complete: (results) => {
            setHeaders(results.meta.fields || []);
            setData(results.data.slice(0, 150));
          },
          error: (error) => console.error("Error parsing CSV:", error),
        });
      } catch (err) {
        console.error("Error fetching CSV:", err);
      }
    };

    fetchCSV();
  }, [csvUrl]);

  return (
    <div style={{ overflowX: "auto" }}>
      <table style={{ borderCollapse: "collapse", width: "100%" }}>
        <thead>
          <tr style={{ backgroundColor: "#f2f2f2" }}>
            {headers.map((header, index) => (
              <th
                key={index}
                style={{
                  border: "1px solid #ddd",
                  padding: "8px",
                  textAlign: "left",
                }}
              >
                {header}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {data.map((row, rowIndex) => (
            <tr key={rowIndex}>
              {headers.map((header, colIndex) => (
                <td
                  key={colIndex}
                  style={{
                    border: "1px solid #ddd",
                    padding: "6px",
                    fontSize: "14px",
                  }}
                >
                  {row[header] || "—"}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}